export const API_URL = process.env.REACT_APP_API_URL || "https://balance-sheet-backend-three.vercel.app";
